import React, { Dispatch, SetStateAction, BaseSyntheticEvent, useState } from "react";
import Swal from "sweetalert2";
import { ContentCreate, DinamicGridCreate } from "../dinamyc-pages.types";
import { Input } from "../../../../components/Input/Input";
import { ModalImagemCropped } from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import useModals from "../../../../hooks/useModals";
import { resizeImage, validateImage } from "../factory/dinamic-page.aux";
import { i18n } from "../../../../translate/i18n";


type Props = {
    data: ContentCreate
    setData: Dispatch<SetStateAction<any>>
}

export function GridImage({ data, setData }: Props) {
    const { showImageCropped } = useModals()
    const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
    const [imageCrop, setImageCrop] = useState<string | null>('')
    const [isCropped, setCropper] = useState<any>(null)


    function getImagetoCrop(file: File) {
        setOriginalImageFile(file) // Armazenar arquivo original
        const url = URL.createObjectURL(file)
        setImageCrop(url)
        showImageCropped()
    }

    const getCropData = async () => {
        if (isCropped) {
            const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
                .then((res) => res.blob())
                .then((blob) => {
                    return new File([blob], 'newAvatar.png', { type: 'image/png' })
                })
            const validImage = await validateImage(file)
            setData(validImage ?? '')
            setImageCrop('')
        }
    }

    const useOriginalImage = async () => {
        if (originalImageFile) {
            const validImage = await validateImage(originalImageFile)
            setData(validImage ?? '')
            setImageCrop('')
        }
    }

    const handleSelectedSize = async (width: number, height: number) => {
        if (originalImageFile) {
            // Criar uma cópia do arquivo original com metadados especiais
            const image = await resizeImage(originalImageFile, width, height)
            setData(image)
            setImageCrop('')
        }
    }

    return (
        <div className='row align-items-center g-3 w-100'>
            <div className='col-12'>
                <Input
                    inputAttr={{ type: 'image-agregador' }}
                    label={i18n.t('agregador_dinamic_page.form.share_image_label')}
                    smalltext={i18n.t('agregador_dinamic_page.form.share_image_small_text')}
                    width='200'
                    height='100'
                    value={data.image}
                    change={(value: BaseSyntheticEvent) => {
                        const file: File | null = value ? value.target.files[0] : null;

                        if (!file) {
                            setData((prev: ContentCreate) => ({
                                ...prev,
                                image: '',
                            }))
                            return
                        }


                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: i18n.t('general.image_2mb_message'),
                            });
                            return;
                        }
                        getImagetoCrop(file as File)
                    }}
                />
            </div>
            <ModalImagemCropped
                imageCrop={imageCrop}
                setCropper={setCropper}
                getCropData={getCropData}
                onUseOriginalImage={useOriginalImage}
                onUseSelectedSize={handleSelectedSize}
                croppedOptions={[{ width: 980, height: 420, value: '980x420' }]}
            />
        </div>
    )
}